<template>
  <b-toast :visible="toast.display" id="my-toast" :variant="toast.type" solid>
    <template #toast-title>
      <div class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">{{ toast.title }}!</strong>
      </div>
    </template>
    {{ toast.description }}
  </b-toast>
</template>

<script>
export default {
  computed: {
    toast() {
      let toastOptions = this.$store.getters.toastOptions;
      return toastOptions;
    },
  },
};
</script>

<style></style>
